/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : TRENDING NOW V2 CONFIGURATION GENERAL SECTION - SORT CONFIG : STYLES --------------- ++++++++++ */
export default theme => ({
  engagementcounters: {
    '& .previewconfig': {
      '& .content': {
      
      }
    }
  }
});
